import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { RoomStatus } from "@/types/room";
import React from "react";

const RoomStatusField = ({
  value,
  onChange,
  label,
  error,
  withLabel = true,
  withOccupiedStatuses = true,
}: {
  value?: RoomStatus;
  onChange: (value: string) => void;
  label?: string;
  error?: string;
  withLabel?: boolean;
  withOccupiedStatuses?: boolean;
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      {withLabel ? <Label>{label || "ROOM STATUS"}</Label> : null}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className="min-w-[140px] justify-between"
          aria-invalid={!!error}
        >
          <SelectValue placeholder="Choose status" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value="all statuses">All Status</SelectItem>
            <SelectItem value={RoomStatus.AVAILABLE}>Free</SelectItem>
            <SelectItem value={RoomStatus.OUT_OF_SERVICE}>
              Unavailable
            </SelectItem>
            {withOccupiedStatuses ? (
              <SelectItem value={RoomStatus.OCCUPIED}>Occupied</SelectItem>
            ) : null}
          </SelectGroup>
        </SelectContent>
      </Select>
      {error ? <p className="text-destructive text-sm">{error}</p> : null}
    </div>
  );
};

export default RoomStatusField;
